import { createLogic } from 'redux-logic'
import { bindRequestLogic } from './utils'
import LabelTypes from '../actionTypes/label'
import { labelAPI, labelImportAPI } from '../api'

const getLabels = bindRequestLogic({
  clientFunc: labelAPI.getLabels,
  type: LabelTypes.GET_LABELS_REQUEST,
  successType: LabelTypes.GET_LABELS_SUCCESS,
  failType: LabelTypes.GET_LABELS_FAILED,
  isQueryParam: true
})

const createLabel = bindRequestLogic({
  clientFunc: labelAPI.createLabel,
  type: LabelTypes.CREATE_LABEL_REQUEST,
  successType: LabelTypes.CREATE_LABEL_SUCCESS,
  failType: LabelTypes.CREATE_LABEL_FAILED
})

const deleteLabel = bindRequestLogic({
  clientFunc: labelAPI.deleteLabel,
  type: LabelTypes.DELETE_LABEL_REQUEST,
  successType: LabelTypes.DELETE_LABEL_SUCCESS,
  failType: LabelTypes.DELETE_LABEL_FAILED
})

const updateLabels = bindRequestLogic({
  clientFunc: labelAPI.updateLabels,
  type: LabelTypes.UPDATE_LABELS_REQUEST,
  successType: LabelTypes.UPDATE_LABELS_SUCCESS,
  failType: LabelTypes.UPDATE_LABELS_FAILED
})

const importLabels = bindRequestLogic({
  clientApi: labelImportAPI,
  clientFunc: labelImportAPI.importLabels,
  type: LabelTypes.IMPORT_LABELS_REQUEST,
  successType: LabelTypes.IMPORT_LABELS_SUCCESS,
  failType: LabelTypes.IMPORT_LABELS_FAILED
})

const updateLabelFromPageTitle = createLogic({
  type: LabelTypes.UPDATE_LABEL_FROM_PAGE_TITLE_REQUEST,
  latest: true,
  process: ({ action }, dispatch, done) => {
    dispatch({
      type: LabelTypes.UPDATE_LABEL_FROM_PAGE_TITLE_SUCCESS,
      payload: action.payload
    })
    done()
  }
})

const getSystemLabels = bindRequestLogic({
  clientFunc: labelAPI.getSystemLabels,
  type: LabelTypes.GET_SYSTEM_LABELS_REQUEST,
  successType: LabelTypes.GET_SYSTEM_LABELS_SUCCESS,
  failType: LabelTypes.GET_SYSTEM_LABELS_FAILED,
  isQueryParam: true
})

const getSystemLabelsForServiceCenter = bindRequestLogic({
  clientFunc: labelAPI.getSystemLabels,
  type: LabelTypes.GET_SYSTEM_LABELS_FOR_SERVICE_CENTER_REQUEST,
  successType: LabelTypes.GET_SYSTEM_LABELS_FOR_SERVICE_CENTER_SUCCESS,
  failType: LabelTypes.GET_SYSTEM_LABELS_FOR_SERVICE_CENTER_FAILED,
  isQueryParam: true
})

const getPagesByModuleId = bindRequestLogic({
  clientFunc: labelAPI.getPagesByModuleId,
  type: LabelTypes.GET_PAGES_BY_MODULE_ID_REQUEST,
  successType: LabelTypes.GET_PAGES_BY_MODULE_ID_SUCCESS,
  failType: LabelTypes.GET_PAGES_BY_MODULE_ID_FAILED
})

const storeSystemLabelInterface = bindRequestLogic({
  clientFunc: labelAPI.storeSystemLabelInterface,
  type: LabelTypes.STORE_SYSTEM_LABEL_INTERFACE_REQUEST,
  successType: LabelTypes.STORE_SYSTEM_LABEL_INTERFACE_SUCCESS,
  failType: LabelTypes.STORE_SYSTEM_LABEL_INTERFACE_FAILED
})

export default [
  getLabels,
  createLabel,
  deleteLabel,
  importLabels,
  updateLabels,
  getSystemLabels,
  updateLabelFromPageTitle,
  getSystemLabelsForServiceCenter,
  getPagesByModuleId,
  storeSystemLabelInterface
]
